<template lang="pug" src="./refer-form.pug"></template>

<script>
// this form uses the mailer at www.opsmiles.com / email.php
import api from 'api'
import axios from 'axios'
export default {
  data: () => {
    return {
      date: '',
      patientName: '',
      dob: '',
      patientPhone: '',
      email: '',
      patientAddress: '',
      dentist: '',
      radiopatient: '',
      carprovider: '',
      evaluation: [],
      evaluationother: '',
      concern: [],
      patientconcerns: '',
      radiographs: '',
      reswork: [],
      postUrl: api + '/rg-mail/v1/refer',
      formSubmitted: false,
      formSuccess: false,
      modalShowing: false
    }
  },
  methods: {
    validate () {
      this.$validator.validateAll()
        .then(result => {
          if (result) {
            this.onSubmit()
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    closeModal () {
      this.modalShowing = false
    },
    onSubmit () {
      this.formSubmitted = true
      axios.post(this.postUrl, {
        date: this.date,
        patientName: this.patientName,
        dob: this.dob,
        patientPhone: this.patientPhone,
        email: this.email,
        patientAddress: this.patientAddress,
        dentist: this.dentist,
        radiopatient: this.radiopatient,
        carprovider: this.carprovider,
        evaluation: this.evaluation,
        evaluationother: this.evaluationother,
        concern: this.concern,
        patientconcerns: this.patientconcerns,
        radiographs: this.radiographs,
        reswork: this.reswork
      })
        .then(res => {
          this.formSuccess = true
          this.modalShowing = true
          setTimeout(() => {
            window.location.href = 'https://www.opsmiles.com/thank-you'
          }, 1500)
          this.date = ''
          this.patientName = ''
          this.dob = ''
          this.patientPhone = ''
          this.email = ''
          this.patientAddress = ''
          this.dentist = ''
          this.radiopatient = ''
          this.carprovider = ''
          this.evaluation = []
          this.evaluationother = ''
          this.concern = []
          this.patientconcerns = ''
          this.radiographs = ''
          this.reswork = []
        })
        .catch(e => {
          console.log(e, 'submitted')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// refer-form.vue?2e6e67b6